import { render } from "./pdfView.vue?vue&type=template&id=0383a742&scoped=true&ts=true"
import script from "./pdfView.vue?vue&type=script&lang=ts"
export * from "./pdfView.vue?vue&type=script&lang=ts"

import "./pdfView.vue?vue&type=style&index=0&id=0383a742&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0383a742"]])

export default __exports__